/**
 * AssetCard — one asset tile in the Overview swimlane matrix.
 *
 *   - background  = the pastel maturity fill (MATURITY_OVERVIEW_COLOR, matches the
 *                   legend swatch) via CSS --card-accent
 *   - top bar     = GREEN iff isNew(asset) (origin === ivt_incubated); legacy/partner/
 *                   global have NO bar. (Figma "red bars" is a typo — new = green.)
 *   - body        = asset name + 八要素完成度:X% + UC name
 *   - click       → navigate to /ivt/assets/:assetId
 */
import { useNavigate } from 'react-router-dom';
import { MATURITY_OVERVIEW_COLOR } from '../../../utils/maturity';
import type { AssetSummary } from '../../../client/IvtHubClient';
import { isNew } from '../utils/assetGrouping';

const FALLBACK_COLOR = '#eceded';

export default function AssetCard({ asset }: { asset: AssetSummary }) {
  const navigate = useNavigate();
  const accent = asset.maturity ? MATURITY_OVERVIEW_COLOR[asset.maturity] : FALLBACK_COLOR;
  const showNewBar = isNew(asset);
  const label = asset.name ?? asset.useCase ?? asset.assetId ?? '—';
  const completeness = asset.elementCompleteness ?? 0;
  const go = () => {
    if (asset.assetId) navigate(`/ivt/assets/${asset.assetId}`);
  };

  return (
    <button
      type="button"
      className="ivt-asset-card"
      style={{ ['--card-accent' as string]: accent }}
      onClick={go}
      aria-label={`Asset ${label}`}
    >
      {showNewBar && <span className="ivt-asset-card__newbar" aria-label="New asset" />}
      <span className="ivt-asset-card__name">{label}</span>
      {completeness > 0 && (
        <span className="ivt-asset-card__completeness">
          八要素完成度：{Math.round((completeness / 8) * 100)}%
        </span>
      )}
      {asset.useCase && <span className="ivt-asset-card__uc">{asset.useCase}</span>}
    </button>
  );
}
